import { styled, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0 }
  to { opacity: 1 }
`;

const fadeOut = keyframes`
  from { opacity: 1 }
  to { opacity: 0 }
`;

export const Container = styled.div<{$isOpen : boolean}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  padding: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.surface.high};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  gap: 16px;
  box-shadow: 3px 0 5px rgba(0, 0, 0, 0.3);
  height: ${({ $isOpen }) => $isOpen ? 'auto' : '182px'};
  z-index: 999999;
`;

export const RowFullWidth = styled.section<{ $isCopyright: boolean }>`
  justify-content: ${({ $isCopyright }) => $isCopyright ? 'center' : 'space-between'};
  display: flex;
  width: 100%;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & button {
    background-color: ${({ theme }) => theme.colors.surface.low};
    border-radius: 50%;
    line-height: 0%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const TextInfo = styled.span<{ $weight: number; size: number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Elza', sans-serif;
  font-size: ${({ size }) => size}px;
  font-weight: ${({ $weight }) => $weight};
  line-height: 19.36px;
  text-align: center;
  gap: 4px;
  color: ${({ theme, $weight }) => $weight === 700 ? theme.colors.text.primary : theme.colors.button.text.disabled};

  & small {

  }
`;

export const Detailing = styled.section<{ $isVisible?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  width: 100%;
  flex: 1;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  background-color: ${({ theme }) => theme.colors.surface.base};
  animation: ${({ $isVisible }) => ($isVisible ? fadeIn : fadeOut)} 0.5s ease-in-out;
`;

export const CopyrightContainer = styled.section`
  display: flex;
  gap: 4px;

  & strong,
  span {
    font-family: Roboto;
    font-size: 10px;
    font-weight: 400;
    line-height: 11.72px;
    text-align: left;
    color: ${({ theme }) => theme.colors.text.secondary};
  }
  & span {
    color: ${({ theme }) => theme.colors.button.text.disabled};
  }
`;
